/* eslint-disable import/no-anonymous-default-export */
import {
  DELETEORDER,
  UPDATEORDER,
  CREATEORDER,
  FETCHORDERS,
  FETCHORDER,
} from "../constants/actionTypes";

export default (orders = [], action) => {
  switch (action.type) {
    case DELETEORDER:
      return orders?._id !== action?.payload?._id;
    case UPDATEORDER:
      return orders?._id === action?.payload._id ? action?.payload : orders;
    case CREATEORDER:
      return [...orders, action.data.data];
    case FETCHORDERS:
      return action.payload;
    case FETCHORDER:
      return action.payload;
    default:
      return orders;
  }
};
